import { Component, Inject, Input, OnChanges } from "@angular/core";
import { ThemeType } from "@ant-design/icons-angular";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { IAssignee, IDeletedAssignee } from "@gtmhub/assignees";
import { APP_CONFIG, IAppConfig } from "@webapp/core/app-config/models/app-config.models";
import { UiTooltipPosition } from "@webapp/ui/tooltip/tooltip.models";
import { UiAvatarSize, UiAvatarType } from "../../avatar.models";

const DEFAULT_AVATAR = "/dist/img/avatars/default_avatar.png";
const DEFAULT_AVATAR_ICON = "travel_world";
const NUCLEO_ICON_NAMESPACE = "fill";
const DEFAULT_BG_COLOR = "#87a6bc";
const UNKNOWN_ICON = "unknown";

@Component({
  selector: "ui-assignee-avatar",
  exportAs: "uiAssigneeAvatar",
  templateUrl: "assignee-avatar.component.html",
  styleUrls: ["./assignee-avatar.component.less"],
  host: {
    "[class.ui-assignee-avatar-x-small]": `size === 'xs'`,
    "[class.ui-assignee-avatar-small]": `size === 'sm'`,
    "[class.ui-assignee-avatar-medium]": `size === 'md'`,
    "[class.ui-assignee-avatar-large]": `size === 'lg'`,
    "[class.ui-assignee-avatar-x-large]": `size === 'xl'`,
  },
})
export class UiAssigneeAvatarComponent implements OnChanges {
  @Input("uiAssignee")
  public assignee: IAssignee | IDeletedAssignee;

  @Input("uiSize")
  public size: UiAvatarSize = "md";

  @Input("uiShowTooltip")
  @InputBoolean()
  public showTooltip?: boolean;

  @Input("uiTooltipPlacement")
  public tooltipPlacement?: UiTooltipPosition;

  public type: UiAvatarType = "picture";
  public picture?: string;
  public icon?: string;
  public backgroundColor = DEFAULT_BG_COLOR;
  public disabled?: boolean;
  public theme?: ThemeType = "outline";
  public isDeleted?: boolean = false;
  public assigneeName?: string;

  public onError: () => void;

  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig) {
    this.onError = (): void => {
      const url = appConfig.cdnStorage.url;
      this.type = "picture";
      this.picture = `${url}${DEFAULT_AVATAR}`;
    };
  }

  public ngOnChanges(): void {
    if (this.assignee && !("isDeleted" in this.assignee)) {
      this.configureAvatarFromAssignee(this.assignee);
    } else {
      this.configureAvatarFromNonExistentAssignee();
    }
  }

  private configureAvatarFromAssignee(assignee: IAssignee): void {
    this.assigneeName = assignee.name;
    if (assignee.picture) {
      this.type = "picture";
      this.picture = assignee.picture;
    } else {
      this.type = "icon";
      this.icon = assignee.avatar || DEFAULT_AVATAR_ICON;
      this.theme = NUCLEO_ICON_NAMESPACE;
      this.backgroundColor = assignee.color || DEFAULT_BG_COLOR;
    }
    this.disabled = assignee.isActive === false;
  }

  private configureAvatarFromNonExistentAssignee(): void {
    this.type = "icon";
    this.icon = UNKNOWN_ICON;
    this.theme = "outline";
    this.isDeleted = true;
  }
}
